export const imgDocs = [
  {
    id: 1,
    url: require("./Media/Photos Gallery/club1.JPG"),
  },
  {
    id: 2,
    url: require("./Media/Photos Gallery/gallery.png"),
  },
  {
    id: 3,
    url: require("./Media/Photos Gallery/gal2.png"),
  },
  {
    id: 4,
    url: require("./Media/Photos Gallery/gal5.png"),
  },
  {
    id: 5,
    url: require("./Media/Photos Gallery/gal8.png"),
  },
  {
    id: 6,
    url: require("./Media/Photos Gallery/gal4.png"),
  },
   {
    id: 56,
    url: require("./Media/Photos Gallery/wedding.png"),
  },
  {
    id: 99,
    url: require("./Media/Photos Gallery/wedding2.png"),
  },
  {
    id: 95,
    url: require("./Media/Photos Gallery/wedding3.png"),
  },
   {
    id: 999,
    url: require("./Media/Photos Gallery/wedding4.png"),
  },
  {
    id: 956,
    url: require("./Media/Photos Gallery/wedding5.png"),
  },
  {
    id: 7,
    url: require("./Media/Photos Gallery/gal9.png"),
  },
  {
    id: 8,
    url: require("./Media/Photos Gallery/gal7.png"),
  },
  {
    id: 9,
    url: require("./Media/Photos Gallery/club2.JPG"),
  },
  {
    id: 10,
    url: require("./Media/Photos Gallery/club3.JPG"),
  },
  {
    id: 11,
    url: require("./Media/Photos Gallery/club4.JPG"),
  },
  {
    id: 12,
    url: require("./Media/Photos Gallery/club5.JPG"),
  },
  {
    id: 13,
    url: require("./Media/Photos Gallery/gal10.png"),
  },
  {
    id: 14,
    url: require("./Media/Photos Gallery/gal11.png"),
  },
  {
    id: 15,
    url: require("./Media/Photos Gallery/gal12.png"),
  },
  {
    id: 16,
    url: require("./Media/Photos Gallery/gal13.png"),
  },
  {
    id: 17,
    url: require("./Media/Photos Gallery/gal14.png"),
  },
  {
    id: 18,
    url: require("./Media/Photos Gallery/gal15.png"),
  },
  {
    id: 19,
    url: require("./Media/Photos Gallery/gal16.png"),
  },
  {
    id: 20,
    url: require("./Media/Photos Gallery/gal17.png"),
  },
  {
    id: 21,
    url: require("./Media/Photos Gallery/gal18.png"),
  },
  {
    id: 22,
    url: require("./Media/Photos Gallery/gal19.png"),
  },
  {
    id: 23,
    url: require("./Media/Photos Gallery/gal20.png"),
  },
  {
    id: 24,
    url: require("./Media/Photos Gallery/gal21.png"),
  },
  {
    id: 25,
    url: require("./Media/Photos Gallery/gal22.png"),
  },
  {
    id: 26,
    url: require("./Media/Photos Gallery/gal23.png"),
  },
  {
    id: 27,
    url: require("./Media/Photos Gallery/gal24.png"),
  },
  {
    id: 28,
    url: require("./Media/Photos Gallery/gal25.png"),
  },
  {
    id: 29,
    url: require("./Media/Photos Gallery/gal26.png"),
  },
  {
    id: 30,
    url: require("./Media/Photos Gallery/gal27.png"),
  },
  {
    id: 31,
    url: require("./Media/Photos Gallery/gal28.png"),
  },
  {
    id: 32,
    url: require("./Media/Photos Gallery/gal29.png"),
  },
  {
    id: 33,
    url: require("./Media/Photos Gallery/gal30.png"),
  },
  {
    id: 34,
    url: require("./Media/Photos Gallery/gal31.png"),
  },
  {
    id: 35,
    url: require("./Media/Photos Gallery/gal32.png"),
  },
  {
    id: 36,
    url: require("./Media/Photos Gallery/gal33.png"),
  }, {
    id: 34,
    url: require("./Media/Photos Gallery/gal34.png"),
  },
  {
    id: 35,
    url: require("./Media/Photos Gallery/gal35.png"),
  },
  {
    id: 36,
    url: require("./Media/Photos Gallery/gal36.png"),
  },
];
